import React from "react";

const MyPageEmpty = () => {
    return (
        <div className="mypage-empty">
            <img src="/images/icon/no_product.png" alt="데이터 없음" className="empty-image" />
            <p className="empty-text">아직 등록된 데이터가 없습니다.</p>
        </div>
    );
};

export default MyPageEmpty;
